// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCz5AkO_4JDwwh5fBZxvbl0288XzjdW_7I',
  authDomain: 'efemeris-b8058.firebaseapp.com',
  projectId: 'efemeris-b8058',
  storageBucket: 'efemeris-b8058.firebasestorage.app',
  messagingSenderId: '798861160394',
  appId: '1:798861160394:web:c3c74d16f02ca2f9b86933',
  measurementId: 'G-60R6Z1F4NB',
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export { storage };

// Registro de usuario. Replica el signUpUser de la app móvil (mismo backend
// efemeris-b8058 y misma forma del documento en la colección "users") para que
// una cuenta creada desde la web funcione igual en la app.
export const signUpUser = async (
  email,
  password,
  name,
  lastName,
  birthDate,
  birthTime,
  birthCountry,
  birthCity,
  birthCoords = null,
) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    const userData = {
      name,
      lastName,
      user_id: user.uid,
      email,
      birthDate,
      birthTime,
      birthCountry,
      birthCity,
      ...(birthCoords?.lat != null && birthCoords?.lng != null
        ? { birthLat: birthCoords.lat, birthLng: birthCoords.lng }
        : {}),
      firstTime: true,
      notifications: false,
      notificaciones_lunares: false,
      premium: false,
      sistemaCasas: 'T',
      membresia: '',
      extraCharts: 5,
      mayores: {
        externos: 5,
        internos: 5,
        luminarias: 8,
        angulos: 3,
        otros: 3,
      },
      menores: {
        externos: 3,
        internos: 3,
        angulos: 3,
        luminarias: 5,
        otros: 2,
      },
    };

    await setDoc(doc(db, 'users', user.uid), userData);

    return user;
  } catch (error) {
    console.error('Error en el registro:', error.message);
    // Si falla la creación del documento, eliminamos el usuario huérfano de Auth.
    if (auth.currentUser) {
      await auth.currentUser.delete().catch((err) => {
        console.error('No se pudo eliminar el usuario huérfano:', err.message);
      });
    }
    throw error;
  }
};
